module.exports = __webpack_public_path__ + "img/PL08144.a865e944.png";